import baseTheme from "styles/themes/base/base";
import { ITheme } from "styles/themes/types";

const maistro: ITheme = baseTheme;

export default maistro;
